import React, { useState, useEffect } from "react";
import stylesheet from "./shop.module.css";
import ProductCard from "../../webincludes/productcard/index";
import Input from "../../component/input/index";
import Footer from "../../webincludes/footer/index";
import Header from "../../webincludes/header/index";
import { getTheme } from "../../../actions/localtheme";
import { connect } from "react-redux";
import { motion as m } from "framer-motion";
import { products } from "./product";

import Wiggle from "../../component/Wiggle/Wiggle";

const Shop = (props) => {
  const [gamechange, setgamechange] = useState("");
  useEffect(() => {
    props.getTheme();
    setgamechange(props.ThemeReducer.theme);
  }, [gamechange]);

  const list = {
    visible: {
      opacity: 1,
      transition: {
        when: "beforeChildren",
        staggerChildren: 0.3,
        delay: 3.3,
      },
    },
    hidden: {
      opacity: 1,
      transition: {
        when: "afterChildren",
      },
    },
  };

  const item = {
    visible: { opacity: 1, x: 0 },
    hidden: { opacity: 0, x: -100 },
  };
  const [Product, setProduct] = useState(products);
  function detailpage() {
    console.log("detail page");
  }

  function addtocart() {
    console.log("add to cart");
  }

  return (
    <>
      <div
        style={{ background: props.ThemeReducer.theme }}
        className={stylesheet.main_shop}
      >
        <div>
          <Header />
        </div>
        <Wiggle />
        <m.div
          initial={{ y: 1000, scale: 0 }}
          animate={{
            y: 0,
            scale: 1,
            transition: {
              duration: 1,
              ease: "easeOut",
              type: "tween",
              delay: 2,
            },
          }}
          className={`container-fluid ${stylesheet.product_side}`}
        >
          <div className="row">
            <div className={stylesheet.ShopCard_header}>
              <div className="d-flex pl-5 pr-4 py-4">
                <img src="https://img.icons8.com/material-outlined/20/f0cc00/left.png" />
              </div>
              <div className="d-flex align-items-center">
                <h6>home</h6>
                <h6 className={stylesheet.navigation_breaker}>.</h6>
                <h6 className={stylesheet.header_current_page}>Shop</h6>
              </div>
            </div>
          </div>
          <div className="row">
            <div className={`col-lg-3 ${stylesheet.category_section} p-5`}>
              <m.h1
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 2, duration: 0.3 }}
              >
                Category
              </m.h1>
              <m.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 2.3, duration: 0.3 }}
                className="pt-5"
              >
                <Input type={"text"} placeholder={"search Here..."} />
              </m.div>
              <div className={stylesheet.category_listing}>
                <m.h5
                  initial={{ x: -100, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ delay: 2.5, duration: 0.2 }}
                >
                  All products
                </m.h5>
                <m.h5
                  initial={{ x: -100, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ delay: 2.7, duration: 0.2 }}
                >
                  Flowers
                </m.h5>
                <m.h5
                  initial={{ x: -100, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ delay: 2.9, duration: 0.2 }}
                >
                  Pre-Rolled
                </m.h5>
                <m.h5
                  initial={{ x: -100, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ delay: 3.1, duration: 0.2 }}
                >
                  CBD Oil
                </m.h5>
                <m.h5
                  initial={{ x: -100, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ delay: 3.3, duration: 0.2 }}
                >
                  Refill
                </m.h5>
                <m.h5
                  initial={{ x: -100, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ delay: 3.5, duration: 0.2 }}
                >
                  Discovery
                </m.h5>
              </div>
            </div>
            <div className={`col-lg-9 p-5 ${stylesheet.productListing}`}>
              <m.div
                variants={list}
                initial="hidden"
                animate="visible"
                className="row"
              >
                {Product !== undefined &&
                Product !== null &&
                Product !== "" &&
                Product.length > 0
                  ? Product.map((data) => (
                      <m.div variants={item} className="col-lg-6 p-4">
                        <ProductCard
                          link={"/productDetail"}
                          func={detailpage}
                          Addcart={addtocart}
                          image={data.image}
                          title={data.title}
                          description={data.description}
                          price={data.price}
                        />
                      </m.div>
                    ))
                  : ""}
              </m.div>
            </div>
          </div>
        </m.div>
      </div>
      <div>
        <Footer />
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  ThemeReducer: state.ThemeReducer,
});

const mapDispatchToProps = (dispatch) => ({
  getTheme: (theme) => dispatch(getTheme(theme)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Shop);
